export default __webpack_public_path__ + "static/media/nbb_dark.70403bf6.png";